// A dependency-free seam for "the session just ended".
//
// The 401 handler lives in utils/index.js, which is already part of an import
// cycle with config/config.js and redux/axiosInstance.js. Having it reach
// directly into the push module would pull the whole redux store into that
// cycle, so listeners register here instead. This file must stay import-free.
const sessionExpiredListeners = new Set();

export const onSessionExpired = (callback) => {
  sessionExpiredListeners.add(callback);
  return () => {
    sessionExpiredListeners.delete(callback);
  };
};

// Fired immediately BEFORE the session is cleared, so listeners can still read
// the outgoing JWT — unregistering a device needs the token of the user who
// owns the row, and that is the last moment it exists.
export const emitSessionExpired = () => {
  sessionExpiredListeners.forEach((callback) => {
    try {
      callback();
    } catch (e) {
      // A listener must not be able to block the session teardown.
    }
  });
};
